module.exports = __webpack_public_path__ + "static/media/krx-public-05.7221d7ac.jpg";